import { Box, Checkbox, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Header from '../../components/Header';
import { Trans, useTranslation } from '../../hooks/useTranslation';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { PrimaryInput } from '../../components/PrimaryInput';
import { ErrorPopUp } from '../../components/ErrorPopUp';
import CouponPage from './CouponPage';
import LuxService from '../../services/LuxService';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
const getCountryCode = (v) => {
  switch (v) {
    case 'france': {
      return { letters: 'FR', code: '+33' };
    }
    case 'germany': {
      return { letters: 'DE', code: '+49' };
    }
    case 'luxembourg': {
      return { letters: 'LU', code: '+352' };
    }
    case 'belgium': {
      return { letters: 'BE', code: '+32' };
    }
    default: {
      return '';
    }
  }
};

function MgmPhoneNumberPage() {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const {
    steps,
    currentStep,
    data,
    setData,
    setCurrentStep,
    trackEvent,
    flowNumber,
  } = useContext(DataContext);
  const [couponPage, setCouponPage] = useState(false);

  const onSubmit = async () => {
    if (!isValidPhoneNumber(data?.phonenumber + ''))
      setData({ ...data, errors: { ...data?.errors, phonenumber: true } });
     else if (
      data?.agreements
        ?.slice(0, flowNumber === 2 /*|| flowNumber === 3 */? 3 : 2)
        .some((x) => !x)
    ) {
      // Only check the first two checkboxes
      setData({
        ...data,
        errors: {
          ...data?.errors,
          agreements: data?.agreements?.map((x, index) =>
            index < 2 || flowNumber === 2 || flowNumber === 3 ? !x : false
          ), // Only mark errors for the first two
        },
      });
    } else if (
      flowNumber === 1 &&
      !data?.isReturning &&
      data?.storeHasCouponlogic && data?.country?.includes('lux')
    ) {
      try {
        setIsLoading(true);

        const res = await LuxService.createUser({
          ...data,
          language: i18n.language,
          flowNumber,
        
          ...(data?.user_uuid ? { user_uuid: data?.user_uuid } : {}),
        });

        setData({
          ...data,
          coupon: res?.coupon?.length ? res?.coupon : data?.discount_code,
          submitted: true,
        });
        setCouponPage(true);
      } catch (err) {
        setData({
          ...data,
          errors: {
            ...data?.errors,
            phonenumber: err?.code,
          },
        });
      } finally {
        setIsLoading(false);
      }
    } else if ((flowNumber === 2 || flowNumber === 3) && data?.country?.includes('lux')) {
      try {
        setIsLoading(true);
        let response = await LuxService.isPhoneReturning(data?.phonenumber, flowNumber);
          if(response?.is_returning){
            throw {code: 1002};
          }
          response = await LuxService.isPhoneReturning(data?.phonenumber, 2);
          if(response?.is_returning){
            throw {code: 1002};
          }
          response = await LuxService.isPhoneReturning(data?.phonenumber, 1);
          if(response?.is_returning){
            throw {code: 1002};
          }

        await LuxService.createUser({
          ...data,
          language: i18n.language,
          flowNumber,
          language: i18n.language,
          flowNumber,
        
          ...(data?.user_uuid ? { user_uuid: data?.user_uuid } : {}),
        });

        setData({
          ...data,
          submitted: true,
          devices: [
            ...(data?.devices ? data?.devices : []),
            {
              src: data?.file?.src,
              code: data?.manualDeviceCode,
              name: data?.manualDeviceCode,
            },
          ],
        });
        setCurrentStep(currentStep + 1);
      } catch (err) {
         if(err?.code+'' === '1002' ){
          setData({
            ...data,
            errors: {
              ...data?.errors,
              phonenumber: '1002',
            },
          });
          setCurrentStep(1);
          return;
        }
        setData({
          ...data,
          errors: {
            ...data?.errors,
            phonenumber: err?.code,
          },
        });
      } finally {
        setIsLoading(false);
      }
    } else {
      setCurrentStep(currentStep + 1);
      return;
    }
  };
  const inputRef = useRef(null);
  const checkboxRef = useRef(null);
  useEffect(() => {
    trackEvent({ nav_to_number: 1 });
  }, [trackEvent]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && isValidPhoneNumber(data?.phonenumber + '')) {
      onSubmit();
    }
  };
  if (couponPage) return <CouponPage />;

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
        position: 'relative',
        pointerEvents: 'all',
      }}
    >
      {data?.errors?.phonenumber ? (
        <ErrorPopUp
         errorText={
            data?.errors?.phonenumber?.length
              ? t('errors.' + data?.errors?.phonenumber)
              : t('errors.102')
          }

          error={data?.errors?.phonenumber}
          setError={(v) =>
            setData({ ...data, errors: { ...data?.errors, phonenumber: v } })
          }
        />
      ) : (
        data?.errors?.agreements
          ?.slice(0, flowNumber === 2 || flowNumber === 3 ? 3 : 2)
          .some((x) => x) && (
          <ErrorPopUp
            errorText={t('emailPage.checkboxesFormatError')}
            error={data?.errors?.agreements
              ?.slice(0, flowNumber === 2 || flowNumber === 3 ? 3 : 2)
              .some((x) => x)}
            setError={(v) =>
              setData({
                ...data,
                errors: { ...data?.errors, agreements: [false, false, false] },
              })
            }
          />
        )
      )}

      <Header steps={steps} currentStep={currentStep} />
      <div
        style={{
          marginTop: '64px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
        }}
      >
       <Typography
                sx={{
                  fontSize: '32px',
                  fontWeight: '700',
                  lineHeight: '38.46px',
                }}
              >
                {t('phoneNumberPage.title')}
              </Typography>
        <Box
          sx={{
            marginTop: '48px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
          }}
        >
       <Box sx={{ marginTop: '16px' }}>
          <div
            className={!data?.isOtherCountry ? 'other-country' : 'country'}
            style={{
              background: 'white',
              borderRadius: '4px',
              border: '',
              padding: '13px',
              paddingInline: '16px',
              position: 'relative',
              overflowX: 'hidden !important',
            }}
          >
            {!!data?.isOtherCountry && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '26px',
                  position: 'absolute',
                  borderRight: '1px solid #E5E5E5',
                  paddingRight: '10px',
                  paddingLeft: '8px',
                  left: '41px',
                  top: '13px',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#808185',
                }}
              >
                {getCountryCode(data?.country)?.code}
              </div>
            )}

            <PhoneInput
              countryCallingCodeEditable={true} // Allow manual deletion of the country code
              withCountryCallingCode={true} // Show country calling code
              value={data?.phonenumber}
              inputRef={inputRef}
              autoFocus
              inputMode="numeric"
              onKeyDown={handleKeyDown}
              onChange={(value) => {
                console.log('oldvalue', data?.phonenumber);
                console.log('newvalue', value);
                setData({
                  ...data,
                  phonenumber: value,
                  errors: { ...data?.errors, phonenumber: false },
                });
              }}
              defaultCountry="LU" // Default country as Luxembourg
            />
          </div>
        </Box>
          <Box
            sx={{
              marginTop: '16px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '20px',
            }}
          >
            {(data?.country?.includes('lux') ? [0, 1] : [0, 1]).map((x) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  let elt = document.getElementById('checkbox-' + x);
                  if (elt) {
                    let agr = data?.agreements;
                    if (!agr?.length) agr = [false, false, false];
                    agr[x] = !data?.agreements[x];
                    let agrErrors = data?.errors?.agreements;
                    if (x < 2 || flowNumber === 2 || flowNumber === 3) {
                      // Only update errors for the first two checkboxes
                      agrErrors = [false, false, false];
                    }

                    setData({
                      ...data,
                      agreements: agr,
                      errors: { ...data?.errors, agreements: agrErrors },
                    });
                  }
                }}
              >
                <Checkbox
                  ref={checkboxRef}
                  checked={data?.agreements[x]}
                  id={'checkbox-' + x}
                  onChange={(e) => {}}
                  checkedIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <mask
                        id="mask0_12757_2793"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_12757_2793)">
                        <rect
                          x="1"
                          y="1"
                          width="20.2223"
                          height="21.12"
                          rx="4"
                          fill="#44546A"
                        />
                        <path
                          d="M9.71874 15.22C9.62223 15.22 9.52667 15.2001 9.43754 15.1614C9.3484 15.1228 9.26744 15.0662 9.19928 14.9948L6.42556 12.0969C6.29571 11.9514 6.22503 11.7589 6.22839 11.56C6.23175 11.3611 6.30889 11.1714 6.44357 11.0307C6.57825 10.89 6.75995 10.8095 6.95039 10.806C7.14083 10.8025 7.32513 10.8763 7.46448 11.0119L9.71874 13.3662L14.7565 8.10583C14.8959 7.97022 15.0802 7.89639 15.2706 7.8999C15.461 7.90341 15.6427 7.98398 15.7774 8.12464C15.9121 8.2653 15.9892 8.45506 15.9926 8.65395C15.996 8.85284 15.9253 9.04533 15.7954 9.19087L10.2382 14.9948C10.17 15.0662 10.0891 15.1228 9.99994 15.1614C9.9108 15.2001 9.81525 15.22 9.71874 15.22Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  }
                  icon={
                    data?.errors?.length && data?.errors?.agreements[x] ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <mask
                          id="mask0_12757_2793"
                          style={{ maskType: 'alpha' }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_12757_2793)">
                          <rect
                            x="1"
                            y="1"
                            width="20.2223"
                            height="21.12"
                            rx="4"
                            fill="rgb(255, 45, 45,0.7)"
                          />
                        </g>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="19"
                          height="19"
                          rx="3.5"
                          stroke="#44546A"
                        />
                      </svg>
                    )
                  }
                  sx={{ padding: '5px' }}
                />
                <Typography
                  sx={{
                    flex: 1,
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '16.82px',
                    textAlign: 'left',

                    color:
                      data?.errors?.length &&
                      data?.errors?.agreements[x] &&
                      (x < 2 || flowNumber === 2 || flowNumber === 3)
                        ? 'rgb(255, 45, 45,0.7)'
                        : '',
                  }}
                >
                  <Trans
                    i18nKey={'emailPage.checkboxes.' + x}
                    t={t}
                    components={{
                      terms: (
                        <a
                          style={{
                            color: '#44546A',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                          target="_blank"
                          href="/terms" //{t('termsLink')}
                        >
                          {t('emailPage.checkboxes.' + x)}
                        </a>
                      ),
                      privacy: (
                        <a
                          style={{
                            color: '#44546A',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                          target="_blank"
                          href={t(
                            data?.country?.includes('lux')
                              ? 'privacyLink'
                              : 'privacyLinkNonResident'
                          )}
                          rel="noopener noreferrer"
                        >
                          {t('emailPage.checkboxes.' + x)}
                        </a>
                      ),
                    }}
                  />
                </Typography>
              </div>
            ))}
          </Box>
        </Box>
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <button
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
            style={{
              outline: 'none',
              border: 'none',
              borderRadius: '50%',
              width: '57px',
              height: '57px',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
            >
              <rect
                opacity="0.1"
                width="57"
                height="57"
                rx="28.5"
                transform="matrix(-1 0 0 1 57 0)"
                fill="#44546A"
              />
              <path
                d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                stroke="#44546A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <PrimaryButton
            style={{ flex: 1 }}
            disabled={
              !isValidPhoneNumber(data?.phonenumber + '') && data?.country?.includes('lux')
            }
            onClick={onSubmit}
          >
            {t('continue')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default MgmPhoneNumberPage;
